import type { ButtonProps } from '@epilot/concorde-elements'
import { Button } from '@epilot/concorde-elements'
import classNames from 'classnames'

import classes from './ChoiceButton.module.scss'

type ChoiceButtonProps = ButtonProps & {
  isSelected?: boolean
}

export const ChoiceButton = (props: ChoiceButtonProps) => {
  const { id, isSelected, className, role, ...rest } = props

  return (
    <Button
      {...rest}
      aria-checked={role === 'radio' ? isSelected : undefined}
      aria-selected={role === 'option' ? isSelected : undefined}
      className={classNames(
        classes.button,
        isSelected && classes.buttonActive,
        className
      )}
      gap={4}
      id={id}
      isToggle
      role={role}
      variant="outlined"
    />
  )
}
